import { useParams } from "react-router-dom";
import { BookingPage } from "./BookingPage";
import { OrderPage } from "./OrderPage";

const SALON_CODE_RE = /^\d{8}$/;
const CLAIM_CODE_RE = /^[1-9]\d{9}$/;

export function CodeRoute() {
  const { code = "" } = useParams();

  if (CLAIM_CODE_RE.test(code)) {
    return <OrderPage claimCode={code} />;
  }

  if (SALON_CODE_RE.test(code)) {
    return <BookingPage />;
  }

  return <BookingPage />;
}
